import {BigDecimal} from '@dms/api/shared';

import type {TenantBankAccount} from './TenantBankAccount';

export type DepositBankTransferPaymentRequestBody = {
  paymentDiscriminator: DepositBankTransferPaymentRequestBody.paymentDiscriminator;
  paymentMethod: DepositBankTransferPaymentRequestBody.paymentMethod;
  dueDate: string;
  tenantBankAccount: TenantBankAccount | null;
  amount: BigDecimal;
  comment: string;
  exchangeRate: string | null;
  supplierInvoiceNumber: string | null;
  dateOfTaxableSupply: string | null;
};

export namespace DepositBankTransferPaymentRequestBody {
  export enum paymentDiscriminator {
    DEPOSIT = 'DEPOSIT',
  }

  export enum paymentMethod {
    BANK_TRANSFER = 'BANK_TRANSFER',
  }
}
